import { Stop } from '../types';

export function computeNights(stops: Stop[]): Map<string, number> {
  const nightsMap = new Map<string, number>();
  const accommodationStops = stops.filter(s => s.type === 'accommodation');
  
  // Group by accommodation name and date
  const accommodationGroups = new Map<string, Stop[]>();
  
  accommodationStops.forEach(stop => {
    const key = `${stop.name}-${stop.date}`;
    if (!accommodationGroups.has(key)) {
      accommodationGroups.set(key, []);
    }
    accommodationGroups.get(key)!.push(stop);
  });
  
  // Compute consecutive nights
  accommodationGroups.forEach((group) => {
    if (group.length > 1) {
      const sorted = group.sort((a, b) => a.date.localeCompare(b.date));
      let nights = 1;
      
      for (let i = 1; i < sorted.length; i++) {
        const prevDate = new Date(sorted[i - 1].date);
        const currDate = new Date(sorted[i].date);
        const diffDays = Math.floor((currDate.getTime() - prevDate.getTime()) / (1000 * 60 * 60 * 24));
        
        if (diffDays === 1) {
          nights++;
        } else {
          // Reset for new sequence
          nights = 1;
        }
      }
      
      group.forEach(stop => {
        nightsMap.set(stop.id, nights);
      });
    } else if (group.length === 1) {
      nightsMap.set(group[0].id, 1);
    }
  });
  
  return nightsMap;
}

